<template>
    <base-modal title="This note contains attachments" @close="$emit('close')" :visible="true" min-height="1rem">
        <p class="title is-5">Do you also want to duplicate them?</p>

        <base-button
            @click="$emit('close')"
            class="btn is-danger"
            text="Close"/>

        <base-button
            @click="$emit('duplicate_note', false)"
            class="btn is-primary"
            text="Duplicate only note"/>

        <base-button
            @click="$emit('duplicate_note', true)"
            class="btn is-primary"
            text="Duplicate with attachments"/>
    </base-modal>
</template>

<script>
export default {
    name: 'NoteDuplicateModal',
};
</script>

<style>
.btn {
    margin: 0 0.5rem 0 0 !important;
}
</style>
